/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Request to estimate supplement processing cost
 * @export
 * @interface EstimateSupplementCostRequest
 */
export interface EstimateSupplementCostRequest {
    /**
     * Number of unmatched line items requiring supplement processing
     * @type {number}
     * @memberof EstimateSupplementCostRequest
     */
    unmatchedLineItemCount: number;
}

/**
 * Check if a given object implements the EstimateSupplementCostRequest interface.
 */
export function instanceOfEstimateSupplementCostRequest(value: object): value is EstimateSupplementCostRequest {
    if (!('unmatchedLineItemCount' in value) || value['unmatchedLineItemCount'] === undefined) return false;
    return true;
}

export function EstimateSupplementCostRequestFromJSON(json: any): EstimateSupplementCostRequest {
    return EstimateSupplementCostRequestFromJSONTyped(json, false);
}

export function EstimateSupplementCostRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): EstimateSupplementCostRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'unmatchedLineItemCount': json['unmatchedLineItemCount'],
    };
}

export function EstimateSupplementCostRequestToJSON(json: any): EstimateSupplementCostRequest {
    return EstimateSupplementCostRequestToJSONTyped(json, false);
}

export function EstimateSupplementCostRequestToJSONTyped(value?: EstimateSupplementCostRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'unmatchedLineItemCount': value['unmatchedLineItemCount'],
    };
}

